"use client"

import Image from "next/image"

type ImageMetadata = {
  src: string
  alt?: string
}

export default function ClientImage({ src, alt }: ImageMetadata) {
  // Skip rendering if src is from example.com (placeholder images)
  if (src?.includes('example.com')) {
    return null
  }
  
  return (
    <Image
      src={src || ""}
      alt={alt || ""}
      width={800}
      height={400}
      className="w-full h-[400px] object-cover rounded-lg my-8"
      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 60vw"
      onError={(e) => {
        // Hide the image if it fails to load
        const target = e.target as HTMLImageElement
        target.style.display = 'none'
      }}
    />
  )
} 